var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5146_17092)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.438 15.438C23.5773 15.2983 23.7429 15.1875 23.9251 15.1119C24.1073 15.0362 24.3027 14.9973 24.5 14.9973C24.6973 14.9973 24.8927 15.0362 25.0749 15.1119C25.2571 15.1875 25.4227 15.2983 25.562 15.438L31.562 21.438C31.7015 21.5775 31.8121 21.743 31.8876 21.9252C31.963 22.1075 32.0019 22.3028 32.0019 22.5C32.0019 22.6972 31.963 22.8925 31.8876 23.0748C31.8121 23.257 31.7015 23.4225 31.562 23.562C31.4225 23.7015 31.257 23.8121 31.0748 23.8876C30.8925 23.963 30.6972 24.0019 30.5 24.0019C30.3028 24.0019 30.1075 23.963 29.9252 23.8876C29.743 23.8121 29.5775 23.7015 29.438 23.562L26 20.121V31.5C26 31.8978 25.842 32.2794 25.5607 32.5607C25.2794 32.842 24.8978 33 24.5 33C24.1022 33 23.7206 32.842 23.4393 32.5607C23.158 32.2794 23 31.8978 23 31.5V20.121L19.562 23.562C19.2803 23.8437 18.8983 24.0019 18.5 24.0019C18.1017 24.0019 17.7197 23.8437 17.438 23.562C17.1563 23.2803 16.9981 22.8983 16.9981 22.5C16.9981 22.1017 17.1563 21.7197 17.438 21.438L23.438 15.438Z",
    fill: "#192F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.718 10.026C16.7164 7.44041 20.5407 6.01242 24.5 6C32.57 6 39.269 12 39.998 19.737C44.774 20.412 48.5 24.411 48.5 29.319C48.5 34.707 44.006 39 38.561 39H11.843C5.624 39 0.5 34.098 0.5 27.954C0.5 22.665 4.298 18.285 9.326 17.175C9.755 14.586 11.42 12.006 13.718 10.026ZM15.677 12.297C13.406 14.256 12.218 16.617 12.218 18.465V19.809L10.883 19.956C6.692 20.415 3.5 23.856 3.5 27.954C3.5 32.355 7.19 36 11.843 36H38.561C42.44 36 45.5 32.964 45.5 29.319C45.5 25.671 42.44 22.635 38.561 22.635H37.061V21.135C37.064 14.475 31.484 9 24.5 9C21.2596 9.01294 18.1305 10.1803 15.677 12.297Z",
    fill: "#192F51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5146_17092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudArrowUp);
export default __webpack_public_path__ + "static/media/CloudArrowUp.ffa948f79594acc0ce8c633ad7319727.svg";
export { ForwardRef as ReactComponent };